import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseOnePaymentOnCurrencyDocumentError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.payment-list-items.one-payment-on-currency-document');
    }
}
